import React, { useContext, useState } from 'react';
import { Step, StepButton, StepLabel, Stepper as MaterialStepper } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';

import AddMeetingContext from 'src/pages/AddMeeting/Context/AddMeeting.context';
import Button from 'src/components/Button/Button';
import Icon from 'src/components/Icon/Icon';

interface StepperProps {
  steps: number[]
}

export default function Stepper({ steps }: StepperProps) {
  const [nextStep, setNextStep] = useState<number>();
  const { activeStep, stepErrors, errorsCount } = useContext(AddMeetingContext);
  const { t } = useTranslation('common');

  return (
    <>
      <input type="hidden" name="nextStep" defaultValue={ nextStep } />
      <div className="add-meeting__stepper-arrow add-meeting__stepper-arrow--back">
        {
          activeStep > 0 && (
            <Button type="submit" onClick={ () => setNextStep(activeStep - 1) }>
              <Icon icon="arrow" />
            </Button>
          )
        }
      </div>

      <MaterialStepper
        alternativeLabel
        nonLinear={ errorsCount > 0 }
        activeStep={ activeStep }
      >
        {
          _.map(steps, (step) => {
            const currStepErrors = _.filter(stepErrors, { step });

            return (
              <Step key={ step }>
                {
                  !_.isEmpty(currStepErrors)
                    ? (
                      <StepLabel error onClick={ () => setNextStep(step) }>
                        { t('addMeeting.errorsCount', { count: currStepErrors.length }) }
                      </StepLabel>
                    )
                    : (
                      <StepButton
                        icon={
                          <span
                            className={
                              classNames('add-meeting__stepper-button', { 'add-meeting__stepper-button--active': activeStep === step })
                            }
                          >
                            { step+1 }
                          </span>
                        }
                        onClick={ () => setNextStep(step) }
                      />
                    )
                }
              </Step>
            );
          })
        }
      </MaterialStepper>

      <div className="add-meeting__stepper-arrow add-meeting__stepper-arrow--next">
        {
          activeStep < steps.length - 1 && (
            <Button type="submit" onClick={ () => setNextStep(activeStep + 1) }>
              <Icon icon="arrow" />
            </Button>
          )
        }
      </div>
    </>
  );
}
